import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import App from './App';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/theme';
import logoMiniIco from '@/assets/logo-mini.ico';

const favicon = document.querySelector('#favicon');
const appleTouchIcon = document.querySelector('#apple-touch-icon');
if (favicon) favicon.href = logoMiniIco;
if (appleTouchIcon) appleTouchIcon.href = logoMiniIco;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
